import {formatMask} from '../../../utils/formatMonetaryToBr'
import {formatDate} from '../../../utils/dayJs/format'
import {useBillingContext} from '../core/billingProvider'
import {BillingDetail} from './billingDetailModal/BillingDetail'
import {BillingEditStatusModal} from './BillingEditStatusModal'
import {KTIcon} from '../../../_metronic/helpers'
import React, {useState} from 'react'
import {BillingShowHistoryModal} from './BillingShowHistoryModal'
import {Billing} from '../core/_models'
import useAuthorization from '../../../hooks/useAuthorization'
import {generateBillingPaymentLink} from './core/_requests'
import {copyToPayment} from '../../../utils/copyToPayment'

export const BillingList = ({saleStatus}) => {
  const {
    billingForView,
    billingsEditStatus,
    billingData,
    setBillingForView,
    setBillingsEditStatus,
  } = useBillingContext()

  const [billingShowHistory, setBillingShowHistory] = useState<Billing>()
  const [billingShowHistoryModal, setBillingShowHistoryModal] = useState(false)
  const isAuthorizedToUpdateStatus = useAuthorization('billings.update_status')

  const badColor = [
    {
      name: 'Pendente',
      color: 'badge badge-warning',
    },
    {
      name: 'Pago',
      color: 'badge badge-success',
    },
    {
      name: 'Cancelado',
      color: 'badge badge-danger',
    },
    {
      name: 'Vencido',
      color: 'badge badge-warning',
    },
  ]

  return (
    <>
      <div className='card-header cursor-pointer'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Informações da Cobrança</h3>
        </div>
      </div>
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='min-w-120px'>Preço</th>
                <th className='min-w-120px'>Forma de pagamento</th>
                <th className='min-w-120px'>Dt de vencimento</th>
                <th className='min-w-120px'>Dt de pagamento</th>
                <th className='min-w-120px'>Parcelas</th>
                <th className='min-w-120px'>Status</th>
                <th className='min-w-120px'>Ações</th>
              </tr>
            </thead>
            <tbody>
              {billingData?.map((billing, index) => {
                const paidInstallments = billing?.installments?.filter((value) => {
                  return value.statusId === 2
                })

                const badgeStatus = badColor.filter((badColor) => badColor.name === billing.status)

                // Cobrança avulsa gerada na alteração de uma parcela de recorrência ou de boleto
                const canCopyPaymentLink =
                  (!!billing?.recurrenceInstallment || !!billing?.settledInstallment) &&
                  billing?.status === 'Pendente' &&
                  billing?.paymentOption?.id === 2

                return (
                  <React.Fragment key={`billingListGroup${index}`}>
                    <tr>
                      <td>{formatMask(billing?.amount)}</td>
                      <td>{billing?.paymentOption?.name}</td>
                      <td>{formatDate(billing?.createdAt)}</td>
                      <td></td>
                      <td>
                        {billing.numberOfInstallments > 1
                          ? paidInstallments.length + ' / ' + billing.numberOfInstallments
                          : 'À vista'}
                      </td>
                      <td>
                        <a className={badgeStatus[0].color}>{billing.status}</a>
                      </td>
                      <td className='text-start'>
                        {billing?.paymentOption?.installmentEnabled && (
                          <button
                            onClick={() => setBillingForView(billing)}
                            className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-2'
                          >
                            <KTIcon iconName='eye' className='fs-3 mr-3' />
                          </button>
                        )}

                        {canCopyPaymentLink && (
                          <button
                            onClick={() =>
                              copyToPayment(() => generateBillingPaymentLink(billing.id!))
                            }
                            title='Copiar link de pagamento'
                            className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-2'
                          >
                            <KTIcon iconName='copy' className='fs-3 mr-3' />
                          </button>
                        )}

                        {isAuthorizedToUpdateStatus &&
                          billing?.status === 'Pendente' &&
                          (billing?.paymentOption?.franchise !== null ||
                            billing.paymentOption.id == 4) &&
                          !(
                            saleStatus === 'Cancelado cliente' ||
                            saleStatus === 'Cancelado clinica' ||
                            saleStatus === 'Troca de Produto'
                          ) && (
                            <button
                              onClick={() => setBillingsEditStatus(billing)}
                              className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-2'
                            >
                              <KTIcon iconName='gear' className='fs-3 mr-3' />
                            </button>
                          )}
                        <button
                          onClick={() => {
                            setBillingShowHistoryModal(true)
                            setBillingShowHistory(billing)
                          }}
                          className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                        >
                          <KTIcon iconName='subtitle' className='fs-3' />
                        </button>
                      </td>
                    </tr>
                  </React.Fragment>
                )
              })}
            </tbody>
          </table>
          {billingForView && <BillingDetail billing={billingForView} />}
          {billingsEditStatus && <BillingEditStatusModal billing={billingsEditStatus} />}
          {billingShowHistoryModal && billingShowHistory && (
            <BillingShowHistoryModal
              billing={billingShowHistory}
              close={() => {
                setBillingShowHistoryModal(false)
              }}
            />
          )}
        </div>
      </div>
    </>
  )
}
